import { AfterViewInit, Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { MiteventsService } from '../../mitevents.service';
  import { Inject, PLATFORM_ID } from '@angular/core';

import Swiper from 'swiper';
import { isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-futek-casestudy',
  templateUrl: './futek-casestudy.component.html',
  styleUrls: ['./futek-casestudy.component.css']
})
export class FutekCasestudyComponent implements AfterViewInit {
  isBrowser:boolean=false;

  swiperBreakpoints={
    320: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1024: { slidesPerView: 2 }
  };
  @ViewChild('empSwiperContainer', { static: false }) empSwiperContainer!: ElementRef;
 
  constructor(private renderer: Renderer2, private titleService: Title,    @Inject(PLATFORM_ID) private platformId: any,

    private metaService: Meta, private eventService: MiteventsService,private seoService:SeoService) {this.isBrowser=isPlatformBrowser(this.platformId);}
baseUrl = Constants.baseUrl;

ngOnInit(): void {
   if(this.isBrowser){     
    AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
  }
  // this.setTitleAndMetaTags();
  this.seoService.createLinkForCanonicalURL();
}

private setTitleAndMetaTags(): void {
  this.titleService.setTitle('Recognition | Awards and Accolades for Maganti IT');

  this.metaService.addTags([
    { name: 'description', content: 'Thank you for the work you did with the rebrand.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: 'Recognition | Awards and Accolades for Maganti IT' },
    { property: 'og:url', content: 'https://mitresource.com/recognition/' },
    { property: 'og:image', content: 'https://mitresource.com/assets/images/recognition/santos-image.png' },
    { property: 'og:description', content: 'Thank you for the work you did with the rebrand.' },
  ]);
}
 

  ngAfterViewInit() {
    if(this.isBrowser){  
    
       const swiperElements=this.empSwiperContainer.nativeElement;
       const shadowRoots=swiperElements.shadowRoot;
     if(shadowRoots){
        const page=shadowRoots.querySelector('.swiper-pagination')
        if(page){
          this.renderer.setStyle(page, 'position', 'unset');  
        }
        else{
          // console.error('Pagination element not found in shadow root');
        }
       }else{
       
        // console.error('Shadow root not found');
       }
     
 
  }
  this.addAriaLabelsToPagination();

  }
  private addAriaLabelsToPagination(): void {
    setTimeout(() => {
      const paginationBullets = this.empSwiperContainer.nativeElement.querySelectorAll('.swiper-pagination-bullet');
      paginationBullets.forEach((bullet: HTMLElement, index: number) => {
        bullet.setAttribute('aria-label', `Go to slide ${index + 1}`);
        bullet.style.minWidth = '44px'; // Ensures touch target size
        bullet.style.minHeight = '44px';
      });
    }, 500); // Ensures Swiper initializes before modifying elements
  }
}